class HeroBannerResizer extends HTMLElement {
  constructor() {
    super();

  }

  /*
    [ALS]: This recalculates section and section content height in order to avoid image zoom on scroll. 
    This only works in IOS since Android devices don't have the same issue.
  **/
  connectedCallback() {

    this.isParallaxEffect = this.dataset.parallaxEffect === "true";
    this.mediaQuery = window.matchMedia("(max-width: 1024px)");

    const utils = new Utils();
    const isIOS = utils.isIOS();
    if (!isIOS) return;

    if (this.isParallaxEffect && this.mediaQuery.matches) {
      const totalHeight = window.innerHeight + 28
      this.closest('section').style.height = `${totalHeight}px`;
      this.style.height = `${totalHeight}px`;
    }

  }

}

if (!customElements.get("hero-banner-resizer")) {
  customElements.define("hero-banner-resizer", HeroBannerResizer);
}
